export const APP_TRANSLATE = {
  "header.points": "points",
  "homepage.readerText.skiptocheckin": "Press enter to navigate to checkin",
  "onboard.wifiAvailable": "WiFi available. Please click here.",
  "vbrinterstitial.bestAvailability": "(best availability)",
  "signup.code.us": "+1",
  "signup.code.fi": "+358",
  "homepage.readerText.skiptocountryselector": "Press enter to navigate to country selector",
  "feedback.flag": "0",
  "homepage.readerText.skiptobooking": "Skip to book a flight",
  "vbrinterstitial.bestPrice": "(best price)",
  "homepage.readerText.skiptommb": "Press enter to navigate to my bookings",
  "manageBooking": "MY BOOKINGS",
  "vbrinterstitial.payWith": "PAY WITH",
  "checkin": "CHECK IN",
  "vbrinterstitial.pointsMoney": "POINTS + MONEY",
  "homepage.readerText.skiptofooter": "Press enter to navigate to footer",
  "vbrinterstitial.points": "points",
  "sasTnC": "SAS Terms & Conditions ",
  "myWifiKeys": "MY SAS WIFI KEYS",
  "paymentSuccess": "PAYMENT SUCCESSFUL",
  "paymentDetails": "PAYMENT DETAILS",
  "wifiLogin.viasatTnC": "Viasat Terms & Conditions",
  "switchDeviceSingle.otherOptions": "OTHER OPTIONS",
  "wifiLogin.label.sasTnC": "I agree to",
  "switchDeviceSingle.continue": "CONNECT ANYWAY",
  "pressEnter": "Press Enter ",
  "reviewAndPay": "REVIEW & PAY",
  "switch.instruction2": "You need to disconnect to connect this <b>{{currentDeviceName}}</b> to SAS WiFi.",
  "wifiLogin.type.ebNumber": "EuroBonus",
  "device.tablet": "TABLET",
  "buyMoreKeys": "BUY ANOTHER KEY",
  "email.heading": "WHERE SHOULD WE SEND THE RECEIPT?",
  "email.overlay.header": "HI THERE, ID TRAVELER!",
  "email.overlay.instruction": "We’ll need your email to get you connected.",
  "wifiKeys.itemName": "SAS WiFi Keys",
  "email.disclaimer": "We won't use your email for anything else.",
  "connectedTime.one": "Connected",
  "switchOldestDevice.text": "If you connect this device, your other device connected for the longest period will be disconnected.",
  "wifi.disclaimer": "The information you’ve entered above will be used to verify that you have access to SAS WiFi.",
  "wifi.disclaimer.text": "There may be temporary service interruptions on some flights over the North Sea, the Bay of Biscay, Russian airspace, Svalbard and the Canary Islands.",
  "wifi.eligibility.text": "If you’re in SAS Go or have a EuroBonus Silver or Member status, use your booking reference to log in.",
  "switchDeviceSingle.text": "If you connect this device, the other device will be disconnected.",
  "loginScreen": "to go back to Wifi login screen",
  "wifi.buyMoreWifiKeys": "BUY MORE WIFI KEYS",
  "wifiLogin.classInfoOne": "If you bought a SAS WiFi Key or travelling",
  "deviceDropdown.label": "Choose device to disconnect",
  "switch.disconnect": "DISCONNECT DEVICE",
  "wifiLogin.type.pnr": "Booking ref.",
  "payNow": "PAY NOW",
  "wifiHeader.payment": "Payment",
  "wifiHeader.wifiKeys": "WiFi Keys",
  "fullInternet.text": "You now have internet access",
  "link.back": "Back link ",
  "connectionInfo": "CONNECTION INFO",
  "payment.heading": "PAY BY CREDIT CARD",
  "device.laptop": "LAPTOP",
  "switch.heading": "WIFI IS ALREADY BEING USED BY OTHER DEVICES",
  "details.info": "We'll use this information to verify you've bought WiFi access and allow you and others to connect from this device or other devices.",
  "wifiLogin.chooseLogin": "CHOOSE HOW TO CONNECT",
  "wifiLogin.textBox.bookingReference": "Booking reference",
  "chatSupport.mainText": "SUPPORT CHAT",
  "sasTnC.back": "BACK",
  "checkbox": "checkbox",
  "wifiHeader.travelers": "Travelers",
  "wifi.connectedToWifi": "You are connected to SAS WiFi",
  "wifiKey": "SAS WiFi Key",
  "startSurfing": "Start surfing on this device",
  "startSuring.button": "CONNECT THIS DEVICE",
  "connectMoreDevices": "To connect more devices, go to <b>www.sas.se/en/onboard</b> and connect with the booking reference and name",
  "connectMoreDevices.charter": "To connect more devices, go to <b>www.sas.se/en/onboard</b> and connect with the email and name",
  "switch.info": "Select the devices that should be connected to WiFi:",
  "wifiLogin.buyWifiAccess": "BUY WIFI ACCESS",
  "wifiKeys": "WIFI KEYS",
  "wifiLogin.sasTnC": "SAS’ Terms & Conditions",
  "switch.continue": "CONTINUE",
  "thisDevice": "this Device",
  "wifiLogin.loggedInCustomer": "Accept terms and conditions and connect to WiFi",
  "wifiTnc.loggedInCustomer": "TERMS & CONDITIONS",
  "tnc.continue": "CONTINUE",
  "wifiTnc.instruction": "The information you’ve entered to log in will be used to verify that you have access to SAS WiFi.",
  "switch.infoText": "You're currently using {{total}} WiFi keys.",
  "switch.instruction1": "You can use your WiFi access on <b>1 device</b> at a time during the flight. To enjoy WiFi on more then 1 device, just buy access for more devices.",
  "wifi.buyMoreAccess": "BUY MORE ACCESS",
  "switch.linkToShowDevice": "Switch connected device instead",
  "wifiLogin.password.label": "Password",
  "cart.taxIncluded": "incl. Taxes and fees",
  "selected": "selected",
  "email": "Email",
  "loginAndAccess": "to login and access Wifi ",
  "wifiLogin.instruction": "Just enter your details below to connect",
  "landingPage": "to go back to wifi landing page ",
  "toContinue": "to continue",
  "wifiLogin.noAccess": "Don't have access?",
  "wifiLogin.classInfoTwo": "in SAS Plus or Business.",
  "wifiLogin.tierInfo": "If you're a Silver member or higher.",
  "closeButton": "Close button ",
  "switch.saveChanges": "SAVE CHANGES",
  "switch.otherOptions": "OTHER OPTIONS",
  "wifi": "WIFI",
  "reqInfo": "* Required information",
  "wifiLogin.informationText": "1 free SAS WiFi key for SAS Plus travelers and EuroBonus members with Diamond, Gold or Silver status.",
  "wifiLogin.label.viasatTnC": "I agree to",
  "enterDetails": "PLEASE ENTER YOUR DETAILS",
  "taxIncluded": "including taxes & fees",
  "notChecked": "not checked ",
  "chatSupport.subText": "Opens in new window",
  "wifiLogin.login.label": "Email/EB number/username/Travel Pass",
  "wifiConnected": "You now have internet access.",
  "connectedName": "Name:",
  "otherOptions": "for other options ",
  "pnr.toolTip": "Your booking reference has 6 characters. You can find it on your boarding card or your booking confirmation.",
  "switch.buyWifi": "BUY WIFI",
  "connectWiFi": "CONNECT TO WIFI",
  "dropdown.loginType": "Login Type dropdown ",
  "wifiLogin.header": "Get started here",
  "feedbackOnboard.flag": "1",
  "validFor": "Valid for",
  "closeError": "to close this error message ",
  "wifiKeys.info": "You can use your WiFi access on 1 device at a time during the flight. To enjoy WiFi on more than 1 device, just buy access for more devices.",
  "wifiKeys.heading": "DEVICES TO CONNECT",
  "wifiLogin.connect": "Continue",
  "myWifi": "MY WIFI",
  "viasatTnC": "VIASAT Terms & Conditions ",
  "loaderText": "JUST A SEC",
  "paymentLoaderText": "HANDLING PAYMENT",
  "getStarted": "LET'S GET STARTED",
  "connectingWifi": "CONNECTING TO WIFI,",
  "device": "device",
  "devices": "devices",
  "sasWifiAccess": "WiFi access for",
  "sasWiFiKeys": "Devices to connect",
  "inclVAT": "/device incl. VAT",
  "pointsPerDevice": " points/device",
  "pointsText": "POINTS",
  "wifi.recep": "We send your receipt to",
  "switchDeviceSingle.currentUser": "WIFI IS ALREADY BEING USED BY ANOTHER DEVICE",
  "sasOnboard": "Onboard - SAS",
  "button": "button ",
  "checked": "is checked ",
  "connectedTime.two": "min ago",
  "wifiHeader.confirmation": "Confirmation",
  "wifiLogin.textBox.lastName": "Last name",
  "total": "TOTAL",
  "connectedPnr": "Booking Reference:",
  "wifiLogin.textBox.firstName": "First name",
  "wifiLogin.buyWifi": "BUY WIFI",
  "viasatTnC.back": "BACK",
  "switch.header": "CONNECT MORE DEVICES",
  "device.smartphone": "SMARTPHONE",
  "loaderSubHeaderTextInKeysPage": "Connect one device or more<br>(You decide in the next step)",
  "loaderTextWhenConnecting": "CONNECTING",
  "loaderSubHeaderTextWhenConnecting": "",
  "paySelection.header": "PAYMENT OPTION",
  "paySelection.instruction": "Please select preferred payment option to buy WiFi",
  "paySelection.paywithPoints": "PAY WITH EB POINTS",
  "paySelection.paywithCard": "PAY WITH CREDIT CARD",
  "alternatePaySelection.header": "INSUFFICIENT BALANCE",
  "alternatePaySelection.instruction": "There is not enough points in the account to complete the transaction of purchasing Wifi access for {{noOfKeys}} device(s). Please select payment with credit card or try again with a fewer number of Wifi sessions",
  "alternatePaySelection.paywithPoints": "CONTINUE WITH POINTS",
  /*"ebCampaign.instruction": "<b>Campaign!</b> Only 750 EB points per device!",*/
  "payConfirmation.header": "PAYMENT CONFIRMATION",
  "payconfirmation.instruction": "Proceeding with the payment will deduct {{noOfKeys*price}} Points from your EuroBonus account and WiFi access will be provided for {{noOfKeys}} device(s)",
  "payConfirmation.confirm": "CONFIRM",
  "payConfirmation.cancel": "CANCEL",
  "receiptInfo": "We’ll email you the receipt. You can use the WiFi keys you bought to log in to your device. And if you need any help, check our FAQs.",
  "messages.4013015": "We couldn't offer any travel extras for your booking. Please try with other options if any.",
  "message.7011017": "Unfortunately, we’re having some technical issues, but we’re working to fix them as soon as possible.",
  "message.7011023": "Unfortunately, the details about the device you're trying to switch to aren't valid. ",
  "message.7011033": "Please enter your last name.",
  "message.7011047": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011005": "Sorry, we can't find this booking. Please enter a valid booking reference.",
  "message.7011002": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011018": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011028": "Unfortunately, some of the information you entered isn't valid. Please try again later. If the problem continues, contact Viasat support for help.",
  "message.7011034": "Please verify your last name.",
  "message.7011044": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011050": "Unfortunately, we can’t seem to validate that you’re onboard. Please try again.",
  "message.7011055": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011010": "Unfortunately, your EuroBonus tier level doesn't qualify for free WiFi, but you can buy access.",
  "message.7011020": "Unfortunately, your EuroBonus tier level and booking class don't qualify for free WiFi, but you can buy access.",
  "message.7011003": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011015": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011029": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011039": "Please enter your booking reference.",
  "message.7011045": "Unfortunately, more than one match found for the details priovided. Unable to proceed with WiFi purchase.",
  "message.7011021": "Unfortunately, the details about the device you're trying to switch from aren't valid. ",
  "messages.6091303": "Your card used for payment was not saved to your profile yet.",
  "message.7011031": "Free WiFi is available to EuroBonus members with Silver status or higher. Please log in again with different details. ",
  "message.7011000": "Unfortunately, we’re having some technical issues, but we’re working to fix them as soon as possible.",
  "message.7011016": "Unfortunately, you've already reached the maximum number of devices you can use. Please switch to a device that is already active. ",
  "message.7011026": "Unfortunately, we’re having some technical issues, but we’re working to fix them as soon as possible.",
  "message.7011008": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011013": "Free WiFi is only available to SAS EuroBonus members. If you're a EuroBonus member, please enter your details again. ",
  "message.7011032": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011042": "Sorry, we can't find this booking. Please enter a valid booking reference.",
  "message.7011001": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011027": "The device(s) you're trying to switch to/from don't seem to be in the correct status. Please try again. ",
  "message.7011037": "Please verify your first name.",
  "message.7011009": "Unfortunately, we can't seem to find your name in the passenger list. Please try again. ",
  "message.7011053": "Unfortunately, we can't seem to find your EuroBonus details in the booking. Please try logging in with your booking reference or buy access.",
  "message.7011014": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011024": "Unfortunately, some details about the device you're trying to switch to are missing. ",
  "messages.6091301": "Unfortunately, we couldn’t save your card to your profile at this moment – Please try to save it manually from your profile settings.",
  "message.7011043": "Unfortunately, we can’t seem to validate that you’re onboard. Please try again.",
  "message.7011006": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011038": "Your first name can't be longer than 32 letters.",
  "message.7011048": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011011": "Sorry, we can't find this traveler. Please enter the name as written in the booking.",
  "message.7011035": "Your last name can't be longer than 32 letters.",
  "messages.6091302": "Your card used for payment was found to be saved in your profile already and no changes has been done.",
  "message.7011030": "Unfortunately , the booking reference provided is not having the correct flight details .Please try connecting free WiFi using your Eurobonus login",
  "message.7011040": "Please verify your booking reference.",
  "message.7011007": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011019": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011049": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "messages.1194025": "Sorry, you've already saved the maximum number of cards that can be saved to your profile",
  "message.7011051": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "messages.6091300": "Your card has been saved to your profile successfully for easy payments in future.",
  "message.7011012": "Unfortunately, WiFi access isn’t free in your booking class, but you can buy WiFi.",
  "message.7011022": "Unfortunately, some details about the device you're trying to switch from are missing.",
  "message.7011036": "Please enter your first name.",
  "message.7011046": "Unfortunately, no WIFI sessions are offered for the passenger details provided. Please try with other options if any.",
  "message.7011041": "Your booking reference can't be longer than 6 characters.",
  "message.7011004": "Unfortunately, something went wrong. Please reconnect and try again. If the problem continues, contact Viasat support for help.",
  "message.7011052": "Unfortunately, we can’t seem to validate that you’re onboard. Please try again.",
  "message.7011058": "We couldn't find your Eurobonus details or you're not a Diamond or Gold member. please use your booking reference.",
  "message.7011059": "Please enter email address.",
  "message.7011060": "Please enter a valid email address.",
  "message.7011061": "You have incorrectly entered zero instead of the alphabet character 'O'.",
  "message.7011062": "You have entered flight number instead of booking reference.",
  "message.7011063": "Unfortunately, your profile does not have sufficient points to complete the purchase.",
  "message.7011064": "There are not enough points in your account for this purchase. You are welcome to use a credit card for purchasing WiFi.",
  "message.7011065": "Unfortunately we are unable to deduct points from your account at this time. You are welcome to use a credit card for purchasing WiFi.",
  "message.7011066": "This voucher code is not valid. Please enter a valid voucher code",
  "message.7011067": "This voucher code is not valid. Please enter a valid voucher code",
  "message.7011068": "Unfortunately, you have  already used this voucher on another device. Please switch a device that is already active",
  "message.7011069": "Unfortunately, One or more information is missing to activate the device.",
  "message.7011070": "Unfortunately, this Voucher is used.",
  "sasTnC.text": "/misc/terms-and-conditions/wifi.content.html",
  "feedbackOnboard.url": "https://qd4763.customervoice360.com/uc/SAS_Training_20160824/35cc/",
  "viasatTnC.text": "/misc/terms-and-conditions/wifi-viasat.content.html",
  "cookie.feedback": "FEEDBACK",
  "cookie.policyUrl.ru": "/ru-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.au": "/au-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.nl": "/nl-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.cn": "/cn-en/travel-info/terms-conditions/cookies/",
  "cookie.personalization.header": "Online behavioural advertising",
  "cookie.description": "We’d like to use technologies, such as cookies, to make your experience with us as enjoyable as possible. We may share information about the way you use our sites and applications with our trusted media, advertising and analytics partners so we can deliver relevant and personalized advertising. By clicking ‘I accept’, you consent to our use of such technologies. You can find more information and manage your preferences by viewing our ",
  "cookie.policyUrl.us": "/us-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.es": "/es-en/travel-info/terms-conditions/cookies/",
  "cookie.policy.linktext": "Cookie Policy",
  "cookie.policy.url": "https://www.sas.se/en/misc/terms-and-conditions/cookie-policy",
  "cookie.policyUrl.fi": "/en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.sg": "/sg-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.de": "/de-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.lu": "/lu-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.gb": "/gb-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.th": "/th-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.no": "/en/travel-info/terms-conditions/cookies/",
  "cookie.personalization.text": "Online behavioural advertising is a way of serving advertisements on the websites you visit and making them more relevant to you and your interests.",
  "cookie.policyUrl.hk": "/hk-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.se": "/en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.pl": "/pl-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.fr": "/fr-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.dk": "/en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.ie": "/ie-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.it": "/it-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.jp": "/jp-en/travel-info/terms-conditions/cookies/",
  "cookie.policyUrl.be": "/be-en/travel-info/terms-conditions/cookies/",
  "cookie.accept": "I ACCEPT",
  "cookie.policyUrl.ch": "/ch-en/travel-info/terms-conditions/cookies/",
  "close": "Close",
  "buyWifiPage.announcement": "Press enter or space to go to buy wifi page",
  "wifiKeys.announcement": "Press Right arrow or numpad plus to increase and Left arrow or numpad minus to decrease the key value.",
  "validForTrip": "VALID FOR TRIP",
  "email.announcement": "Please enter an email address",
  "sasLogo.announcement": "Graphic SAS logo Scandinavian Airlines press enter to go back to homepage",
  "currentlySelected": "Currently selected",
  "boughtWifi.announcement": "Payment is successful and the receipt has been sent to your email. {{wifiKey}} wifi keys are brought using the booking ref {{pnr}} by {{firstname}} {{lastname}}. Please press enter or space to start surfing.",
  "footercontent": "© 2023 Scandinavian Airlines System-Denmark-Norway-Sweden,reg.nr 902001-7720, 195 87 Stockholm",
  "buymoredevice": "BUY ACCESS FOR MORE DEVICES",
  "grabit.tailid": "SAS2207",
  "grabit.flightnumber": "SK2207",
  "goTo.grabIt":"GO TO OFFER",
  "emailOverlay.commercialHeading": "WHERE SHOULD WE SEND YOUR RECEIPT?",
  "emailOverlay.commercialInstruction_email": "Your receipt will be sent to the email below. If you wish to get it to a different address please correct it in the box below and press Continue. To protect your personal information, we will not store this email address.",
  "emailOverlay.commercialInstruction": "To protect your personal information, we will not store this email address.",
  "emailOverlay.staffHeading": "HI THERE, ID TRAVELER!",
  "emailOverlay.staffInstruction":"Please enter your email to get connected",
  "emailAddress.text":"Your email address:",
  "enterEmailAddress.text":"Add email address where you want the report to be sent",
  "a321.tailid": "SE-DMO,SE-DMR",
  "a321.bannerid": "a321-full-access"
}